import { getAuthAxiosBackend } from "../helpers/axios"

class FormArtistServices{

    get(id){
        return getAuthAxiosBackend().get('form-artist/artists/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('form-artist/artists', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('form-artist/artists/' + id)
    }
}

export default new FormArtistServices()